import customFetch from "../util/config/axiosConfig";
import { ApiResponse } from "../types/responseType";
import { toast } from "sonner";
import { getErrorMessage } from "../util/functions/UniversalFunctions";
import { NoticePayload, NoticeResponse } from "../types/noticeBoardType";

const noticeBoardApis = {
  //post
  createNotice: async (
    payload: NoticePayload,
  ): Promise<ApiResponse<NoticePayload> | undefined> => {
    try {
      const response = await customFetch.post("/api/v1/notice/add", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error: any) {
      console.error("Error while adding notice:", error);
      toast.error(getErrorMessage(error) || "Failed to add notice");
    }
  },

  // GET
  getNotices: async (
    branchCode: string,
  ): Promise<NoticeResponse | undefined> => {
    try {
      const response = await customFetch.get(
        `/api/v1/notice/filter?branchCode=${branchCode}`,
      );

      return response.data;
    } catch (error: any) {
      console.error("Error while fetching notice:", error);
      toast.error(getErrorMessage(error) || "Failed to load Notice");
    }
  },

  // delelte
  deleteNoticeBoard: async (noticeId: number) => {
    try {
      const response = await customFetch.delete(`/api/v1/notice/${noticeId}`);

      return response.data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to delete notice");
      throw err;
    }
  },
};

export default noticeBoardApis;
